/*联系我们*/
export default {
  path: '/contact-info',
  component: resolve => require(['@/components/details_figure/contact-info'], resolve)
}
